import React from 'react';
import {t} from 'ttag';

import Grid from 'components/grid/grid.jsx';
import Product from '../product/product.jsx';
import {useAppContext} from 'app-context.js';
import getBitrix24TopLevelDomain from '../get-bitrix24-top-level-domain.js';

const WhatcrmProductList = () => {
  const {user, lang} = useAppContext();

  const kommo = lang === 'ru' ? 'amocrm.ru' : 'kommo.com';
  const bitrix24TopLevelDomain = getBitrix24TopLevelDomain(lang);

  const isKommo =
    user.domain.includes('amocrm') ||
    user.domain.includes('kommo') ||
    user.crm === 'AMO' ||
    user.crm == 'AVITO' ||
    user.crm === 'TELEGRAM';

  const isBitrix24 =
    user.domain.includes('bitrix24') ||
    user.crm === 'B24' ||
    user.crm === 'TELPHGRAM' ||
    user.crm == 'AVITOBX';

  const isPipedrive = user.crm == 'PIPEDRIVE' || user.crm == 'TGPIPEDRIVE';

  const web = window.location.host.endsWith('.ru')
    ? `${process.env.REACT_APP_WEB_RU}?lang=${lang}`
    : `${process.env.REACT_APP_WEB}?lang=${lang}`;

  const productList = [
    {
      description_short: 'Whatcrm Web',
      description: t`Messaging using multiple WhatsApp and Telegram accounts.`,
      image: '/static/img/products/whatcrm-web.png',
      link: {
        href: web,
        text: t`Open`
      },
      guide:
        lang == 'ru'
          ? 'https://whatcrm.gitbook.io/whatcrm-docs/produkty/whatcrm-web'
          : 'https://whatcrm.gitbook.io/whatcrm-docs/english/integrations-products/whatcrm-web'
    },
    {
      description_short: t`WhatsApp for Kommo`,
      description: t`Integration via WhatsApp Web API. Recommendations for stable operation: the phone is always online, on charge and with a good internet connection.`,
      image: '/static/img/products/whatcrm-whatsapp.png',
      link: {
        href: `https://www.${kommo}/oauth/?state=state&mode=popup&client_id=2c45cb68-3a03-4bad-a531-b2c83bda6b08`,
        text: t`Install`
      },
      skip: isBitrix24 || isPipedrive || user.crm == 'AMO'
    },
    {
      description_short: t`Telegram for Kommo`,
      description: t`Send and receive messages to your personal Telegram phone number. Dialogues and messages are unlimited.`,
      image: '/static/img/products/whatcrm-telegram.png',
      link: {
        href: `https://www.${kommo}/oauth/?state=state&mode=popup&client_id=12e7ab9a-c237-4a24-b70a-3b63a291216e`,
        text: t`Install`
      },
      skip: isBitrix24 || isPipedrive || user.crm == 'TELEGRAM'
    },
    {
      description_short: t`Avito for Kommo`,
      description: t`The integration allows customers to automate their work with Avito and communicate with customers directly from Kommo.`,
      image: '/static/img/products/whatcrm-avito.png',
      link: {
        href: `https://www.${kommo}/oauth/?mode=popup&client_id=9e031bf8-d33d-470a-9986-15ebfd9d7410`,
        text: t`Install`
      },
      skip: isBitrix24 || user.crm == 'AVITO' || isPipedrive
    },
    {
      description_short: t`WhatsApp for Bitrix24`,
      description: t`Integration via WhatsApp Web API. Recommendations for stable operation: the phone is always online, on charge and with a good internet connection.`,
      image: '/static/img/products/whatcrm-whatsapp.png',
      link: {
        href: isBitrix24
          ? `https://${user.domain}/market/detail/telphin.whatsapp_ot_whatcrm/`
          : `https://www.bitrix24.${bitrix24TopLevelDomain}/apps/app/telphin.whatsapp_ot_whatcrm/`,
        text: t`Install`
      },
      skip: isKommo || isPipedrive || user.crm == 'B24'
    },
    {
      description_short: t`Telegram for Bitrix24`,
      description: t`Send and receive messages to your personal Telegram phone number. Dialogues and messages are unlimited.`,
      image: '/static/img/products/whatcrm-telegram.png',
      link: {
        href: isBitrix24
          ? `https://${user.domain}/market/detail/telphin.telegram_ot_whatcrm/`
          : `https://www.bitrix24.${bitrix24TopLevelDomain}/apps/app/telphin.telegram_ot_whatcrm/`,
        text: t`Install`
      },
      skip: isKommo || isPipedrive || user.crm == 'TELPHGRAM'
    },
    {
      description_short: t`WhatsApp Checker for Bitrix24`,
      description: t`Verify phone number from entities (lead, contact, deal and company) in WhatsApp. Use with Bitrix24 business processes.`,
      image: '/static/img/products/whatcrm-checker.png',
      link: {
        href: `https://www.bitrix24.ru/apps/app/telphin.whatsapp_checker_ot_whatcrm/`,
        text: t`Install`
      },
      skip:
        (user.domain.includes('bitrix24') && user.crm == 'CHECKER') ||
        bitrix24TopLevelDomain != 'ru' ||
        isKommo ||
        isPipedrive
    },
    {
      description_short: t`WhatsApp for monday.com`,
      description: t`Communicate effectively with customers via WhatsApp and integrate this communication with monday.com.`,
      image: '/static/img/products/whatcrm-whatsapp.png',
      link: {
        href: 'https://auth.monday.com/oauth2/authorize?client_id=7ca9d4564e2f61767840e2c08ca36a43&response_type=install',
        text: t`Install`
      },
      skip: user.crm == 'MONDAY' || isKommo || isPipedrive || isBitrix24
    }
  ].filter(item => !item.skip);

  return (
    <div>
      <Grid>
        {productList.map((item, i) => (
          <Product key={i} product={item} />
        ))}
      </Grid>
    </div>
  );
};

export default WhatcrmProductList;
